// extracted by mini-css-extract-plugin
export default {"card":"CardMartiller_card__xFx1j","header":"CardMartiller_header__tnVzM","photo":"CardMartiller_photo__lTVQ2","name":"CardMartiller_name__gWz6V","link":"CardMartiller_link__zCYul"};